import CityPageTemplate from "../city-template/CityPageTemplate";
import { steamboatSpringsConfig } from "./data";

export default function SteamboatSpringsPage() {
  return <CityPageTemplate config={steamboatSpringsConfig} />;
}